module.exports = __webpack_public_path__ + "img/Pop-up_06_1.d9552d68.png";